module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("AXEL")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("F")]), _vm._v("ree agency is not just a term but the most decisive decision we all made before the universe was ever formed from chaos’s fractal")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And your right to decide was won in a terrible pre-mortal battle and made it absolutely your choice to either follow God’s laws or get forever wrapped around Satan’s gory axel.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The Son of the Morning and a third of the host of heaven were cast out and forbade to ever know the mortal condition")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And for all of eternity dwell as cesspools in the agonizing bitter darkness of a fate more terrible than even perdition.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Satan and all his minions are for all of eternity denied sight and feel of God’s pure love and light")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And will do all manner of evil to pervert as many souls as possible from entering the gates of heaven to honor God the Father and Christ, the only begotten son, whose throne sits next to God’s on the right.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The war for your soul is real in every way there could ever be")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And there is no beguiling slimy trick beyond Satan’s power to employ in his arsenal of evil to ensnare and trap you in a place where you can never on your own get free.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("God’s plan of salvation is absolutely the only way your soul can ever be set free")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And our Lord and Savior’s agonizing death on the cross at Calvary gave all of humanity the gates of heaven’s only key.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Free agency is not just a term but the most decisive decision we all made before the universe was ever formed from chaos’s fractal")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And your right to decide was won in a terrible pre-mortal battle and made it absolutely your choice to either follow God’s laws or get forever wrapped around Satan’s gory axel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72430cfb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap012.vue
// module id = 102
// module chunks = 0